import { TFunction } from 'i18next'

export const queryErrorHandler = (context: string) => {
  return (error: Error) => {
    // eslint-disable-next-line no-console
    console.error(`Failed to ${context}: ${error}`)
  }
}

// Extended function - logs error and returns translated message
export const queryErrorHandlerWithMessage = (context: string, t: TFunction) => {
  return (error: Error): string => {
    // eslint-disable-next-line no-console
    console.error(`Failed to ${context}: ${error}`)

    // Return appropriate translated message
    // Detect network blocked error (TypeError with "Failed to fetch")
    if (error instanceof TypeError && 'message' in error && error.message === 'Failed to fetch') {
      return t('common.errors.networkBlocked')
    }
    return error.message || t('common.errors.somethingWentWrong')
  }
}
